// extracted by mini-css-extract-plugin
export default {"switch-options":"switch-options--zXrkq9F8","switchOptions":"switch-options--zXrkq9F8"};